import { createFileRoute, Outlet, useLocation } from "@tanstack/react-router";
import { ContractPurchaseDetail } from "@/features/contracts/contract-purchase-detail";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/kontrakty/rozliczenia-zakup/$id")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.szablony",
			location.pathname,
		);
	},
	component: ContractPurchaseRoute,
});

function ContractPurchaseRoute() {
	const { id } = Route.useParams();
	const pathname = useLocation({ select: (location) => location.pathname });
	const detailPath = `/kontrakty/rozliczenia-zakup/${id}`;

	if (pathname === detailPath || pathname === `${detailPath}/`) {
		return <ContractPurchaseDetail />;
	}

	return <Outlet />;
}
